/******PageProjet******/

import { RegexThis } from "./00-Appendix.js";

/*PAGE*/
export default function PageProjet(data) {
  let myProjectData0 = data.data;

  let myProjectData = checkArticle();

  function checkArticle() {
    let thisPage = window.location.href;

    for (let i in myProjectData0) {
      if (thisPage.includes(RegexThis(myProjectData0[i].name))) {
        return myProjectData0[i];
      }
    }
  }

  //Getting paragraphs
  function getParagraphs(R, i) {
    if (R != undefined && R != null && R != "") {
      return <p key={"paragraph" + i}>{R}</p>;
    }
  }

  /*DOM*/
  return (
    <div className="homepage realisations partenaires Contact PageProjet">
      {(() => {
        //MAIN IMG
        return (
          <img
            fetchpriority="high"
            src={"/img/real/" + myProjectData.img + ".webp"}
            className="mainImgProjet"
            alt={"illustration du projet" + " " + myProjectData.name}
          />
        );
      })()}

      <div className="mainText   mainTextProjet">
        {/*TITLE*/}
        <h2>{myProjectData.name}</h2>
        <div className="mainLeft">
          {/*SUBTITLE*/}
          <p className="realSub">{myProjectData.desc}</p>

          {/*DESCRIPTION 1*/}
          {myProjectData.DepictP1.map((R, i) => getParagraphs(R, i))}
        </div>
        {/*SIDE IMG 1*/}
        {(() => {
          if (
            myProjectData.sideImg1 != undefined &&
            myProjectData.sideImg1 != null &&
            myProjectData.sideImg1 != ""
          )
            return (
              <div className="mainRight">
                <img
                  fetchpriority="high"
                  src={"/img/real/" + myProjectData.sideImg1 + ".webp"}
                  className="mainImgProjet"
                  alt={"illustration 2  du projet" + " " + myProjectData.name}
                />
              </div>
            );
        })()}
      </div>

      {/*DESCRIPTION 2 & SIDE IMG 2*/}

      {(() => {
        if (
          myProjectData.DepictP2[0] != undefined &&
          myProjectData.DepictP2[0] != null &&
          myProjectData.DepictP2[0] != ""
        ) {
          return (
            <div className="mainText   mainTextProjet2">
              {/*DESCRIPTION 2 */}
              <div className="mainLeft">
                {myProjectData.DepictP2.map((R, i) => getParagraphs(R, i))}
              </div>

              {/* SIDE IMG 2*/}
              {(() => {
                if (
                  myProjectData.sideImg2 != undefined &&
                  myProjectData.sideImg2 != null &&
                  myProjectData.sideImg2 != ""
                )
                  return (
                    <div className="mainRight">
                      <img
                        fetchpriority="high"
                        src={"/img/real/" + myProjectData.sideImg2 + ".webp"}
                        className="mainImgProjet"
                        alt={
                          "illustration 2  du projet" + " " + myProjectData.name
                        }
                      />
                    </div>
                  );
              })()}
            </div>
          );
        }
      })()}

      {/*DESCRIPTION 3 & SIDE IMG 3*/}
      {(() => {
        if (
          myProjectData.DepictP3[0] != undefined &&
          myProjectData.DepictP3[0] != null &&
          myProjectData.DepictP3[0] != ""
        ) {
          if (
            myProjectData.DepictP2[0] != undefined &&
            myProjectData.DepictP2[0] != null &&
            myProjectData.DepictP2[0] != ""
          ) {
            return (
              <div className="mainText   mainTextProjet">
                {/*DESCRIPTION 3 */}
                <div className="mainLeft">
                  {myProjectData.DepictP3.map((R, i) => getParagraphs(R, i))}
                </div>

                {/* SIDE IMG 3*/}
                {(() => {
                  if (
                    myProjectData.sideImg3 != undefined &&
                    myProjectData.sideImg3 != null &&
                    myProjectData.sideImg3 != ""
                  )
                    return (
                      <div className="mainRight">
                        <img
                          fetchpriority="high"
                          src={"/img/real/" + myProjectData.sideImg3 + ".webp"}
                          className="mainImgProjet"
                          alt={
                            "illustration 3  du projet" +
                            " " +
                            myProjectData.name
                          }
                        />
                      </div>
                    );
                })()}
              </div>
            );
          } else {
            return (
              <div className="mainText   mainTextProjet2">
                {/*DESCRIPTION 3 */}
                <div className="mainLeft">
                  {myProjectData.DepictP3.map((R, i) => getParagraphs(R, i))}
                </div>

                {/* SIDE IMG 3*/}
                {(() => {
                  if (
                    myProjectData.sideImg3 != undefined &&
                    myProjectData.sideImg3 != null &&
                    myProjectData.sideImg3 != ""
                  )
                    return (
                      <div className="mainRight">
                        <img
                          fetchpriority="high"
                          src={"/img/real/" + myProjectData.sideImg3 + ".webp"}
                          className="mainImgProjet"
                          alt={
                            "illustration 3  du projet" +
                            " " +
                            myProjectData.name
                          }
                        />
                      </div>
                    );
                })()}
              </div>
            );
          }
        }
      })()}
      {(() => {
        if (
          myProjectData.link != undefined &&
          myProjectData.link != null &&
          myProjectData.link != ""
        ) {
          return (
            <a
              className="contactButton"
              href={myProjectData.link}
              target="_blank"
            >
              <p>Découvrir le projet</p>
            </a>
          );
        }
      })()}
    </div>
  );
}
